<ng-template #optionTemplate let-option>
    <div
        class="ap-selector-modal__option"
        [ngClass]="{ 'ap-selector-modal__option--currency': option?.template === 'currency' }"
        role="option"
        data-testid="option"
        [attr.aria-selected]="isSelected(option) ? 'true' : null"
        [attr.id]="option.id"
        [attr.data-id]="option.id"
    >
        @if (showIcons() && option.icon) {
            <ap-icon
                class="ap-selector-modal__icon"
                [name]="option.icon"
                color="inherit"
                size="large"
                data-testid="option-icon"
                [attr.data-id]="option.id"
            ></ap-icon>
        }
        <span class="ap-selector-modal__body" [attr.data-id]="option.id">
            <span class="ap-selector-modal__title" [attr.data-id]="option.id" data-testid="option-title">
                <span [attr.data-id]="option.id">{{ option.title }}</span>
                @if (option.subtitle) {
                    <span
                        [class.negative-amount]="option.subtitle.includes('-')"
                        class="ap-selector-modal__subtitle"
                        data-testid="option-subtitle"
                        [attr.data-id]="option.id"
                        [innerHTML]="option.subtitle"
                    ></span>
                }
            </span>
            <span class="ap-selector-modal__text" [attr.data-id]="option.id" data-testid="option-text">
                {{ option.text }}

                @if (option.subOptions && option.labels) {
                    <span class="ap-selector-modal__sub-options" data-testid="option-sublabel" [attr.data-id]="option.id">
                        {{ option.labels?.description | apContent }}
                    </span>
                }
            </span>
            @if (option.extra) {
                <span
                    class="ap-selector-modal__extra"
                    [attr.data-id]="option.id"
                    data-testid="option-extra"
                    [innerHTML]="option.extra"
                ></span>
            }
        </span>
    </div>
</ng-template>

<div
    class="ap-selector-modal__listbox"
    tabindex="0"
    role="listbox"
    data-testid="listbox"
    (focus)="listboxFocus()"
    (keydown)="listboxKeyDown($event)"
    (click)="listboxClick($event)"
    [attr.aria-label]="title()"
    [attr.aria-activedescendant]="selectedOption() ? selectedOption().id : null"
>
    @if (groups()) {
        @for (group of groups(); track i; let i = $index) {
            @if (getGroupOptions(group.id).length > 0) {
                <ul class="ap-selector-modal__group" role="group" data-testid="group">
                    @if (group.title) {
                        <li class="ap-selector-modal__group__title" role="presentation" data-testid="group-title">
                            {{ group.title }}
                        </li>
                    }
                    @for (option of getGroupOptions(group.id); track option.id) {
                        <ng-container [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ $implicit: option }"> </ng-container>
                    }
                </ul>
            }
        }
    } @else {
        @for (option of options(); track i; let i = $index) {
            <ng-container [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ $implicit: option }"> </ng-container>
        }
    }
</div>
